import React from "react";
import { Box, Typography } from "@mui/material";
import { APPIMAGE_BASE_URL } from "../../config/constants";
const PaymentSecureBox = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#F0F0F0", // Light gray background
        borderRadius: "12px",
        padding: "16px",
        position: "relative",
        fontSize: "14px",
        color: "#333",
        marginTop:"10px"
      }}
    >
      <Typography>
        Your payment is secured by PhonePe gateway.
      </Typography>

      {/* Powered By section */}
      <Box
        sx={{
          position: "absolute",
          bottom: 8,
          right: 12,
          display: "flex",
          alignItems: "center",
        }}
      >
        <Typography variant="caption" sx={{ mr: 1 }}>
          Powered by
        </Typography>
        <Box
          component="img"
          src={`${APPIMAGE_BASE_URL}/appimages/phonepe.png`}
          alt="PhonePe"
          sx={{ height: 30 }}
        />
      </Box>
    </Box>
  );
};

export default PaymentSecureBox;
